export const ONBOARD_CONSTANTS = {
    LANGUAGE: 'en',
    POS: 'lu',
    ENABLE_ONBOARD: 'true',
    ENABLE_IP_CHECK: 'true',
    REDIRECTION_URL: 'http://sas.viasat.com/',
    GET_DEVICE: 'services/wifi/devices/',
    ACTIVATE_DEVICE: 'services/wifi/devices/<<token>>/activate',
    GET_DEVICE_TYPES: 'services/wifi/devices?passengerId=<<passengerId>>',
    SWITCH_DEVICE: 'services/wifi/device/switch',
    WIFI_LOGO_URL: '/content/dam/sas/images/icons/WiFi.svg',
    SAS_TAC: 'misc/terms-and-conditions/wifi.content.html',
    VIASAT_TAC: 'misc/terms-and-conditions/wifi-viasat.content.html',
    VIASAT_GET_TOKEN: 'https://msi.viasat.com:9100/v1/devices',
    VIASAT_API_KEY_TEST: 'test-api-key-access-self-info-only',
    VIASAT_API_KEY_PROD: 'b39a7cc52a674a47c97365853efbb6005e7118dc0a3f96d17d',
    OAUTH_URL: 'authorize/oauth/token?grant_type=client_credentials',
    ERROR_TRALSALION_KEY: 'message.',
    NOTIFICATION_TRALSALION_KEY: 'messages.',
    DEFAULT_ERROR: '7011044',
    DISCONNECT_WIFI: 'services/wifi/devices/<<token>>/deactivate',
    RESERVATION_UPDATE_CONTACTINFO_URL: 'reservation/reservation/RESERVATION_ID/contactinformation',
    GET_PASSENGER: 'services/wifi/passengers?bookingReference=<<pnr>>&firstName=<<fn>>&lastName=<<ln>>',
    GET_PASSENGER_PAXID: 'services/wifi/passengers?passengerId=<<passengerId>>',
    GET_PASSENGER_EMAIL: 'services/wifi/passengers?passengerId=<<passengerId>>&emailId=<<emailId>>',
    GET_PASSENGER_EB: '/services/wifi/passengers?firstName=<<fn>>&lastName=<<ln>>&ebNumber=<<eb>>',
    GET_OFFERS_CALL: 'offers/ancillaries',
    GET_OFFERS: 'offers',
    GET_POINTS: 'services/wifi/points?passengerId=<<passengerId>>',
    ORDER_POINTS: 'services/wifi/points/purchase',
    ENABLE_DEVICE_TOKEN_STRIPPING: true,
    RESERVE_PRODUCT_URL: 'ancillaries/checkout/reserve',
    INITIATE_RESERVE_URL: 'ancillaries/checkout/initiate',
    SAVECARD_URL: 'customer/<<CUSTOMERID>>/preferences/payment/addOrUpdate',
    CHECKOUT_URL: 'ancillaries/checkout/<<CHECKOUTID>>/pay',
    CONFIRM_URL: 'ancillaries/checkout/<<CHECKOUTID>>/confirm',
    RELEASE_URL: 'ancillaries/checkout/<<CHECKOUTID>>/products/release',
    REVIEW_URL: 'ancillaries/checkout/<<CHECKOUTID>>/review',
    GET_FLIGHT: 'services/wifi/flights/',
    CHATER_VOUCHER_ORG_DST: 'BJL',
    CHARTER: 'charter',
    COMMERCIAL: 'commercial',
    GET_RESERVATION: 'reservation/reservation?bookingReference=<<pnr>>&lastName=<<ln>>&context=RES',
    CHATBOT_TESTURL: 'https://inflight.viasat.com/SAS/FAQ?airline=SAS&language=en',
    CHATBOT_PRODURL: 'https://inflight.viasat.com/SAS/FAQ?airline=SAS&language=en',
    NULLCHECKCOUNT: 2,
    SPECIAL_LANGUAGE: ['zh', 'ja', 'ru'],
    CURRENCY_POS: ['SE', 'DK', 'NO', 'LU', 'US','CA'],
    ANCFULL_FILLMENT: true,
    GRABIT_URL: "https://gri-nonprod.viasat.io/sas-test/?deviceId=",
    AuthDomainProd : 'auth.flysas.com',
    ClientIdProd : '43zEYDsa6r8iQxqCYTfAlnY2R4e2cRzf',
    callbackURLProd : 'https://www.flysas.com/onboard/',
    ForgotPwdLinkProd : 'https://flysas.com/en/forgot-password/',
    labelsUrlProd : 'https://flysas.com/v2/cms-www/fragment/labels/customer-profile-common/',
    registerLinkProd : 'https://flysas.com/en/register/',
    AuthDomainTest : 'auth-stage.flysas.com',
    ClientIdTest : 'rP3NnOLVF8YvL3PVeOHbo83SjhwPlyYH',
    callbackURLLocalhost : 'http://localhost:4200/onboard/',
    callbackURLTest : 'https://test.flysas.com/onboard/',
    ForgotPwdLinkTest : 'https://test.flysas.com/en/forgot-password/',
    labelsUrlTest : 'https://test.flysas.com/v2/cms-www/fragment/labels/customer-profile-common/',
    registerLinkTest : 'https://test.flysas.com/en/register/',
}

export const HTTP_CONSTANTS = {
    errorDespOne: 'Looks like Authorization server is UP!!! Please get a token to access the API..',
    errorDespTwo: 'Supplied token is expired!! Authorization server is UP to get a new/refresh token..'
}
